//Install
import React, { Component } from "react";
//Install
import { Container, Row, Col } from "react-bootstrap";
//Install
import Header from "../../Header";
//Install
import Footer from "../../Footer";
//Install
import Form from "../../Shortcode/Contact/Form";

//Element
class Default extends Component {
    //Element
    componentDidMount() {
        //Element
        document.title = "İletişim Bilgileri : Temas Elektrik Taahhüt"
        //Element
        document.getElementsByTagName("meta")["description"].content = "Temas Elektrik, Sürdürülebilir ve Güvenilir Enerji Hizmetleri İle Her Dokunuş, Geleceği Değer Katar."
        //Element
        let URL = "https://temaselektrik.com/iletisim"
        //Element
        let Canonical = document.querySelector("link[rel='canonical']")
        //Element
        Canonical.setAttribute("href", URL);
    }
    //Element
    render() {
        //Element
        const Content = React.createElement("div", { className: "website-application" },
            //Element
            React.createElement(Header, {}),
            //Element
            React.createElement("main", { className: "S6pt64 C96Q4r pEO064 a527eB d3c437" },
                //Element
                React.createElement("section", { className: "S6pt64 C96Q4r pEO064 a527eB f1d74t" },
                    //Element
                    React.createElement("div", { className: "S6pt64 C96Q4r pEO064 a527eB p33e0e" },
                        //Element
                        React.createElement("figure", { className: "S6pt64 C96Q4r pEO064 a527eB f3792q" })
                    )
                ),
                //Element
                React.createElement("section", { className: "S6pt64 C96Q4r pEO064 a527eB gq620v" },
                    //Element
                    React.createElement(Container, {},
                        //Element
                        React.createElement(Row, {},
                            //Element
                            React.createElement(Col, { md: 12 },
                                //Element
                                React.createElement("div", { className: "S6pt64 C96Q4r pEO064 a527eB v431h7" },
                                    //Element
                                    React.createElement("div", { className: "S6pt64 C96Q4r pEO064 a527eB yk8549" },
                                        //Element
                                        React.createElement("h1", { className: "S6pt64 C96Q4r pEO064 a527eB u7760y" },
                                            //Element
                                            "İletişim Bilgileri"
                                        )
                                    )
                                )
                            ),
                            //Element
                            React.createElement(Col, { md: 6 },
                                //Element
                                React.createElement("div", { className: "S6pt64 C96Q4r pEO064 a527eB q95k0u" },
                                    //Element
                                    React.createElement("h2", { className: "S6pt64 C96Q4r pEO064 a527eB q887o2" },
                                        //Element
                                        "İletişim Kurun ",
                                        //Element
                                        React.createElement("strong", {},
                                            //Element
                                            "Enerjinizi "
                                        ),
                                        //Element
                                        "Güce Dönüştürelim."
                                    ),
                                    //Element
                                    React.createElement("p", { className: "S6pt64 C96Q4r pEO064 a527eB j39v3u" },
                                        //Element
                                        "Temas Elektrik Taahhüt Olarak, Projelerinizde İhtiyaç Duyduğunuz Tüm Teknik Desteği ve Profesyonel Hizmetleri Sağlamak İçin Daima Burada Olacağız."
                                    ),
                                    //Element
                                    React.createElement("ul", { className: "S6pt64 C96Q4r pEO064 a527eB h41650" },
                                        //Element
                                        React.createElement("li", {},
                                            //Element
                                            React.createElement("a", { className: "S6pt64 C96Q4r pEO064 a527eB", href: "https://maps.app.goo.gl/xtD7zwNA2KHFqonJA" },
                                                //Element
                                                React.createElement("span", { className: "S6pt64 C96Q4r pEO064 a527eB" },
                                                    //Element
                                                    "Konum"
                                                ),
                                                //Element
                                                React.createElement("label", { className: "S6pt64 C96Q4r pEO064 a527eB" },
                                                    //Element
                                                    "Mecidiyeköy, Atakan Sk. No: 16 / B, 34710 Şişli / İstanbul"
                                                )
                                            )
                                        ),
                                        //Element
                                        React.createElement("li", {},
                                            //Element
                                            React.createElement("a", { className: "S6pt64 C96Q4r pEO064 a527eB", href: "mailto:info@temaselektrik.com" },
                                                //Element
                                                React.createElement("span", { className: "S6pt64 C96Q4r pEO064 a527eB" },
                                                    //Element
                                                    "E-mail"
                                                ),
                                                //Element
                                                React.createElement("label", { className: "S6pt64 C96Q4r pEO064 a527eB" },
                                                    //Element
                                                    "info@temaselektrik.com"
                                                )
                                            )
                                        ),
                                        //Element
                                        React.createElement("li", {},
                                            //Element
                                            React.createElement("a", { className: "S6pt64 C96Q4r pEO064 a527eB", href: "tel:+905325700821" },
                                                //Element
                                                React.createElement("span", { className: "S6pt64 C96Q4r pEO064 a527eB" },
                                                    //Element
                                                    "Telefon"
                                                ),
                                                //Element
                                                React.createElement("label", { className: "S6pt64 C96Q4r pEO064 a527eB" },
                                                    //Element
                                                    "+90 532 570 08 21"
                                                )
                                            )
                                        ),
                                        //Element
                                        React.createElement("li", {},
                                            //Element
                                            React.createElement("a", { className: "S6pt64 C96Q4r pEO064 a527eB", href: "tel:+902122121297" },
                                                //Element
                                                React.createElement("span", { className: "S6pt64 C96Q4r pEO064 a527eB" },
                                                    //Element
                                                    "Telefon"
                                                ),
                                                //Element
                                                React.createElement("label", { className: "S6pt64 C96Q4r pEO064 a527eB" },
                                                    //Element
                                                    "+90 212 212 12 97"
                                                )
                                            )
                                        )
                                    )
                                )
                            ),
                            //Element
                            React.createElement(Col, { md: 6 },
                                //Element
                                React.createElement("div", { className: "S6pt64 C96Q4r pEO064 a527eB t571rm" },
                                    //Element
                                    React.createElement(Form, {})
                                )
                            ),
                            //Element
                            React.createElement(Col, { md: 12 },
                                //Element
                                React.createElement("div", { className: "S6pt64 C96Q4r pEO064 a527eB o221bv" },
                                    //Element
                                    React.createElement("iframe", { src: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3008.010916909923!2d28.991192075517123!3d41.06875401569973!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x14cab75e9882448d%3A0x1faef822d73f0b03!2sTEMAS%20ELEKTR%C4%B0K!5e0!3m2!1str!2str!4v1759650453041!5m2!1str!2str", width: "600", height: "450", className: "ob2A34" })
                                )
                            )
                        )
                    )
                )
            ),
            //Element
            React.createElement(Footer, {})
        )
        //Element
        return (
            Content
        );
    }
}
//Element
export default Default;